module.exports = __webpack_public_path__ + "img/video.1ffd2b74.svg";